import React, { Fragment } from "react";
import { Save as SaveIcon, SettingsBackupRestore } from "@mui/icons-material";
import { useAuth, useHasRole } from "@homesusa/auth";
import { RoleUser } from "@homesusa/core";
import { FormToolbar as HusaFormToolbar } from "@homesusa/form";
import {
  HeaderOutlet,
  HeaderTitle,
  SubmitButton,
  useTheme
} from "@homesusa/layout";
import { DeleteIconButton, InfoIconButton } from "core/components";
import { UserDetail } from "core/interfaces";
import { UserContext } from "../contexts";
import { useDeleteUser, useUpdateUser, useActivateUser } from "../hooks";
import { ReportManagementButton } from "./report-managment-button.component";
import { SelectEmployeeRoleButton } from "./select-employee-role-button.component";

function UserToolbar(): JSX.Element {
  const { user: currentLoggedUser } = useAuth();
  const { user } = React.useContext(UserContext);
  const { isMlsAdministrator } = useHasRole();
  const { variant } = useTheme();
  const onSave = useUpdateUser();
  const onDelete = useDeleteUser();
  const onActivate = useActivateUser();
  const getUserName = (user: UserDetail): string => {
    if (user) {
      return `User - ${user.firstName} ${user.lastName} (${user.email})`;
    } else return "";
  };
  const headerTitle = (
    <HeaderTitle title={getUserName(user)}>
      {currentLoggedUser?.id == user?.id &&
        currentLoggedUser?.role == RoleUser.MLSAdministrator && (
          <SelectEmployeeRoleButton />
        )}
    </HeaderTitle>
  );
  const headerNode =
    variant === "old" ? (
      headerTitle
    ) : (
      <HeaderOutlet>{headerTitle}</HeaderOutlet>
    );
  return (
    <Fragment>
      <HusaFormToolbar>
        {headerNode}
        <HusaFormToolbar.Right>
          {!user.isDeleted && (
            <SubmitButton
              onClick={onSave}
              buttonProps={{
                variant: "contained",
                startIcon: <SaveIcon />,
                color: "primary"
              }}
            >
              Save
            </SubmitButton>
          )}
          {isMlsAdministrator &&
            (user.isDeleted ? (
              <SubmitButton
                onClick={onActivate}
                buttonProps={{
                  variant: "contained",
                  startIcon: <SettingsBackupRestore />,
                  color: "primary"
                }}
              >
                Restore
              </SubmitButton>
            ) : (
              <DeleteIconButton
                text="Delete User"
                onClick={onDelete}
                modalBody={<p>Are you sure you want to delete this user?</p>}
              />
            ))}
          <ReportManagementButton />
          <InfoIconButton information={user} />
        </HusaFormToolbar.Right>
      </HusaFormToolbar>
    </Fragment>
  );
}

export default UserToolbar;
